import Appsignal from '@appsignal/javascript';
const key = import.meta.env.VITE_APPSIGNAL_KEY;
export const appsignal = new Appsignal({ key });
